import { render, staticRenderFns } from "./AssignmentPerformance.vue?vue&type=template&id=d1462812&scoped=true&"
import script from "./AssignmentPerformance.vue?vue&type=script&lang=js&"
export * from "./AssignmentPerformance.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPerformance.vue?vue&type=style&index=0&id=d1462812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1462812",
  null
  
)

export default component.exports